import { indexItems } from '@/mocks/homeData';

export default function IndexSection() {
  return (
    <section id="index" className="py-16 md:py-24 bg-background-50">
      <div className="px-4 md:px-6 max-w-[1400px] mx-auto">
        <div className="text-center mb-12 md:mb-16">
          <h2 className="font-heading text-2xl md:text-4xl font-bold text-foreground-950 mb-4">
            专题合集
          </h2>
          <p className="text-foreground-600 text-base md:text-lg max-w-2xl mx-auto">
            精心策划的影视专题，帮你快速发现感兴趣的好内容
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-5">
          {indexItems.slice(0, 4).map((item, idx) => (
            <div
              key={idx}
              className="group bg-background-100 rounded-2xl p-6 border border-background-200/70 hover:border-primary-200 transition-all duration-300 cursor-pointer"
            >
              <div className="flex items-start justify-between mb-4">
                <div className="w-11 h-11 rounded-xl bg-primary-100 flex items-center justify-center group-hover:bg-primary-500 transition-colors duration-300">
                  <i className={`${item.icon} text-lg text-primary-600 group-hover:text-white transition-colors duration-300`}></i>
                </div>
                <span className="text-xs font-medium text-foreground-400 bg-background-200/70 px-2.5 py-1 rounded-full whitespace-nowrap">
                  {item.count}部
                </span>
              </div>
              <h3 className="font-heading text-base font-semibold text-foreground-900 mb-2 group-hover:text-primary-600 transition-colors">
                {item.title}
              </h3>
              <p className="text-foreground-600 text-sm">
                {item.description}
              </p>
            </div>
          ))}
        </div>

        <div className="mt-5 grid grid-cols-1 sm:grid-cols-3 gap-4 md:gap-5">
          {indexItems.slice(4).map((item, idx) => (
            <div
              key={idx}
              className="group bg-background-100 rounded-2xl p-5 border border-background-200/70 hover:border-primary-200 transition-all duration-300 cursor-pointer flex items-center gap-4"
            >
              <div className="w-11 h-11 rounded-xl bg-accent-100 flex items-center justify-center flex-shrink-0 group-hover:bg-accent-500 transition-colors duration-300">
                <i className={`${item.icon} text-lg text-accent-600 group-hover:text-white transition-colors duration-300`}></i>
              </div>
              <div className="min-w-0">
                <h3 className="font-heading text-base font-semibold text-foreground-900 group-hover:text-accent-600 transition-colors truncate">
                  {item.title}
                </h3>
                <p className="text-foreground-600 text-sm flex items-center gap-2">
                  {item.description}
                  <span className="text-xs text-foreground-400 whitespace-nowrap">{item.count}部</span>
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}